import gql from "graphql-tag";

const attachmentReferenceMutations = {


    createAttachmentReference: gql`
        mutation CreateAttachmentReference($alias: String, $description: String, $copies: Int, $attachment_id: Int, $contact_id: Int, $invoice_id: Int, $project_id: Int, $site_journal_id: Int, $site_journal_material_id: Int, $site_journal_problem_id: Int, $building_id: Int, $contract_id: Int) {
            createAttachmentReference(alias: $alias, description: $description, copies: $copies, attachment_id: $attachment_id, contact_id: $contact_id, invoice_id: $invoice_id, project_id: $project_id, site_journal_id: $site_journal_id, site_journal_material_id: $site_journal_material_id, site_journal_problem_id: $site_journal_problem_id, building_id: $building_id, contract_id: $contract_id) {
                id,
                alias,
                description,
                copies,
                attachment_id,
                contact_id,
                invoice_id,
                project_id,
                site_journal_id,
                site_journal_material_id,
                site_journal_problem_id,
                building_id,
                contract_id
            }
        }
    `,
    updateAttachmentReference: gql`
        mutation UpdateAttachmentReference($id: ID!, $alias: String, $description: String, $copies: Int, $attachment_id: Int, $contact_id: Int, $invoice_id: Int, $project_id: Int, $site_journal_id: Int, $site_journal_material_id: Int, $site_journal_problem_id: Int, $building_id: Int, $contract_id: Int) {
            updateAttachmentReference(id: $id, alias: $alias, description: $description, copies: $copies, attachment_id: $attachment_id, contact_id: $contact_id, invoice_id: $invoice_id, project_id: $project_id, site_journal_id: $site_journal_id, site_journal_material_id: $site_journal_material_id, site_journal_problem_id: $site_journal_problem_id, building_id: $building_id, contract_id: $contract_id) {
                id,
                alias,
                description,
                copies,
                attachment_id,
                contact_id,
                invoice_id,
                project_id,
                site_journal_id,
                site_journal_material_id,
                site_journal_problem_id,
                building_id,
                contract_id
            }
        }
    `,
};

export default attachmentReferenceMutations;